import { PublicationVirtualItem } from '@modules/shared/components/publications/PublicationVirtualItem';
import { usePublicationAvailableGlobalList } from './publications.store';
import {
  createMediaQuery,
  token,
  useIsMobile,
} from '@ferreri/prever-component-lib';
import styled from '@emotion/styled';

export const PublicationsAvailableGlobalList = () => {
  const isMobile = useIsMobile();
  const { data: publicationList } = usePublicationAvailableGlobalList();

  return (
    <PublicationListContainer>
      {publicationList?.slice(0, 6)?.map((publication) => (
        <PublicationVirtualItem
          key={publication.id}
          publication={publication}
          href={`/publications/${publication.id}`}
          maxWidth={isMobile ? '327px' : undefined}
        />
      ))}
    </PublicationListContainer>
  );
};

const PublicationListContainer = styled.div`
  gap: ${token.spacing.spacingSmall};
  width: 100%;
  display: flex;
  flex-direction: row;
  overflow-x: scroll;

  & > * {
    flex: 0 0 260px;
    min-width: 0;
  }

  /* Hide scrollbar */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }

  padding: ${token.spacing.spacingSmall} ${token.spacing.spacingMedium};
  margin: -${token.spacing.spacingSmall} 0;

  ${createMediaQuery({
    desktop: {
      display: 'grid',
      gridTemplateRows: 'auto',
      gridAutoFlow: 'dense',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      overflow: 'unset',
      padding: `0 ${token.spacing.spacingXxLarge}`,
    },
    ultrawide: {
      display: 'grid',
      gridAutoFlow: 'dense',
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
      padding: `0 ${token.spacing.spacingXxLarge}`,
      overflow: 'unset',
      margin: '0 auto',
    },
  })};
`;
